import React from "react";
import "./Policy.css";

export default function TermsOfService() {
  return (
    <div className="policy-page">
      <h1>Terms of Service</h1>
      <p>Last updated: August 2025</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using TravXplo’s website and services, you agree to these Terms of
        Service. If you do not agree, please discontinue use of our platform.
      </p>

      <h2>2. Services Offered</h2>
      <p>
        TravXplo provides AI-generated travel itineraries, recommendations,
        hotel information, and related services. These are for informational
        purposes only and should be verified before booking.
      </p>

      <h2>3. User Responsibilities</h2>
      <p>
        - Provide accurate information when filling out forms. <br />
        - Use the services for personal or business travel planning only. <br />
        - Do not misuse or attempt to interfere with the platform.
      </p>

      <h2>4. Subscription & Usage</h2>
      <p>
        Free accounts are limited to 5 itineraries. Paid subscriptions allow
        extended access. Subscriptions are non-transferable and must be used by
        the registered account holder.
      </p>

      <h2>5. Limitation of Liability</h2>
      <p>
        TravXplo is not responsible for travel delays, cancellations, or losses
        that may occur. Our itineraries are recommendations and do not replace
        official travel advice.
      </p>

      <h2>6. Updates to Terms</h2>
      <p>
        We may update these Terms from time to time. Continued use of our
        platform means you accept the updated Terms.
      </p>
    </div>
  );
}
